import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './index.css';
import App from './App.tsx';
import { store } from './store/store';
import ErrorBoundary from './components/ErrorBoundary';
import { AuthProvider } from './contexts/AuthContext';
import monitoring from './services/monitoring';
import {
  MONITORING_CONFIG,
  validateEnvironment,
  isDevelopment,
} from './config/env';

// Validate environment variables
validateEnvironment();

// Initialize monitoring services
monitoring.init({
  sentryDsn: MONITORING_CONFIG.sentryDsn,
  googleAnalyticsId: MONITORING_CONFIG.googleAnalyticsId,
  enableAnalytics: MONITORING_CONFIG.enableAnalytics,
  enablePerformanceMonitoring: MONITORING_CONFIG.enablePerformanceMonitoring,
  enableConsoleErrors: isDevelopment, // Only in development
});

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000, // 1 minute
      retry: 1,
    },
    mutations: {
      onError: (error: Error) => {
        // Track mutation errors
        monitoring.captureError({
          message: `React Query Mutation Error: ${error.message}`,
          severity: 'high',
          tags: { type: 'react_query_mutation_error' },
          extra: { error },
        });
      },
    },
  },
});

createRoot(document.getElementById('root')!).render(
  // <StrictMode>
    <ErrorBoundary>
      <Provider store={store}>
        {/* <QueryClientProvider client={queryClient}> */}
          <BrowserRouter>
            <AuthProvider>
              <App />
            </AuthProvider>
          </BrowserRouter>
        {/* </QueryClientProvider> */}
      </Provider>
    </ErrorBoundary>
  // </StrictMode>
);
